export default {
  HOME: '/',
  CLASSES: '/classes',
  TECHNOLOGY: '/technology',
  PRODUCT: '/product',
  CONFIRMATION: '/confirmation',
  CHECKOUT: '/checkout',
  PRIVACY_LEGAL_TERMS: '/privacy-legal-terms',
  ABOUT: '/about',
  FINANCING: '/financing'
};
